module.exports = __webpack_public_path__ + "img/jf-bg.8450b20b.png";